"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-elevation";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/elevation/lib/constants.js
// module id = ./node_modules/@react-mdc/elevation/lib/constants.js
// module chunks = 1